import React from "react";
import "./price.css";
import Input from "../../components/Input";

export default function Price({ handleChange }) {
  return (
    <div>
      <h3 className="sidebar-title">Price</h3>
      <div>
        <Input
          handleChange={handleChange}
          value="all"
          title="all"
          name="pricing"
        />
        <Input
          handleChange={handleChange}
          value={50}
          title="$0-50"
          name="pricing"
          color="all"
        />
        <Input
          handleChange={handleChange}
          value={100}
          title="$50-100"
          name="pricing"
        />
        <Input
          handleChange={handleChange}
          value={150}
          title="$100-150"
          name="pricing"
        />
        <Input
          handleChange={handleChange}
          value={200}
          title="Over $150"
          name="pricing"
        />
      </div>
    </div>
  );
}
